export default __webpack_public_path__ + "static/media/paris.6497cde5.jpg";